export const packagesStateName = "packages";

export const packagesInitialState = {
  packages: { list: [], loading: false },
};
